import Apply from "../images/apply.jpg";
import "./careerDetails.css";
import Footer from "./footer";
import { useParams } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { GoDotFill } from "react-icons/go";
import uploadCv from "../images/Upload.png";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import AOS from 'aos';


const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});

const CareerDetail = () => {

      const [qualities, setQualities] = useState([])
      const [requirements, setRequirments] = useState([])
      const [responsibilities, setResponsibilites] = useState([])
      const [summary, setSummary] = useState("")
       const [intro, setIntro] = useState("")
      const [role, setRole] = useState("")
      const [jobLevel, setJobLevel] = useState("")
      const [jobType, setJobType] = useState("")
      const [jobMode, setJobMode] = useState("")
      const [jobLocation, setJobLocation] = useState("")

     


function buttonCall() {
    const target = document.getElementById("apply-form");
    target.scrollIntoView({ behavior: "smooth" });
  }

    const params = useParams()

      useEffect(() => {
      
         AOS.init({
          offset: 0,
          duration: 1000,
          once: true
        });
      
          
      }, [])

     useEffect( () => {
       client
       .query({
         query: gql`
         query($id:ID!){
      careersBy(id:$id) {
        jobsPage {
         introduction
           contract
          entryLevel
          fullTime
          introduction
          hybrid
          fieldGroupName
          midLevel
          onsite
          partTime
           remote
          location

          qualities {
            list
          }
      requirements {
        list
      }
      responsibilities {
        list
      }
      summary
      role
      introduction
      }
      }
       }
       `,
       variables: {id:params.id}
       })
       .then(async result => { 
        console.log(result)
       setRole(result.data.careersBy.jobsPage.role)
       setQualities(result.data.careersBy.jobsPage.qualities)
       setResponsibilites(result.data.careersBy.jobsPage.requirements)
       setRequirments(result.data.careersBy.jobsPage.responsibilities)
       setSummary(result.data.careersBy.jobsPage.summary)
       setIntro(result.data.careersBy.jobsPage.introduction)


                    //set the job type 
              if(result.data.careersBy.jobsPage.contract){
                     setJobType("Contract")  
               }
              if(result.data.careersBy.jobsPage.fullTime){
                      setJobType("Full Time")
              }
              if(result.data.careersBy.jobsPage.partTime){
                        setJobType("Part Time") 
               }
                //set the job level 
              if(result.data.careersBy.jobsPage.entryLevel){
                     setJobLevel("Entry Level") 
               }
              if(result.data.careersBy.jobsPage.midLevel){
                  setJobLevel("Mid Level")
              }
              if(result.data.careersBy.jobsPage.seniorLevel){
                      setJobLevel("Senior Level") 
               }

                    //set the job mode 
              if(result.data.careersBy.jobsPage.remote){
                       setJobMode("Remote")
                      
               }
              if(result.data.careersBy.jobsPage.hybrid){
                   setJobMode("Hybrid")
                  
              }
              if(result.data.careersBy.jobsPage.onSite){
                       setJobMode("Onsite")
                  
               }
                  
          
               setJobLocation(result.data.careersBy.jobsPage.location)
       })
    
    
    
    
    }, [])   


          
       let   listRequirement = requirements.map((listing, i) => 

            <li>
              {listing.list} {" "}
            </li>
        
            ) 

        let  listResponsibilities = responsibilities.map((listing, i) => 

            <li>
              {listing.list} {" "}
            </li>
        
            ) 

          let     listQualities = qualities.map((listing, i) => 

            <li>
              {listing.list} {" "}
            </li>
        
            ) 


  return (
    <>
      <div className="leadership-container">
        <div className="leadership-cover">
          <img className="leadership-bg" src={Apply} />
          <div className="leadership-content">
            <div className="abt-text-ldr ldr-txt">
              <h1 className="lead-h1 ">Apply for Role</h1>
              <p id="grey-ldr" className="grey-p">
                Begin your journey with a team committed to excellence,
                innovation, and people-first values.
              </p>
              <a id="mobile-btn-apply" className="btn-trns" onClick={buttonCall}>
                {" "}
                Submit your application{" "}
                <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="apply-container">
        <div className="apply-left">
          <h2 className="apply-h2 mb-3" id="apply-form"> {role} </h2>

          <div id="border-hr" className="job-info mb-4">
            <p className="job-location jobChar">{jobMode}</p>
            <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
            <p className="job-type jobChar">{jobLocation}</p>
            <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
            <p className="job-working-mode jobChar">{jobType}</p>
            <GoDotFill className="ms-1 me-1" style={{ fontSize: "8px" }} />
            <p className="job-experience jobChar">{jobLevel}</p>{" "}
          </div>
          <p className="mb-4">
            {intro}{" "}
          </p>
          <h5 className="mb-3" data-aos="fade-up" data-aos-delay="200">Key Responsibilities </h5>
          <ul className="mb-3" data-aos="fade-up" data-aos-delay="200">
            {listResponsibilities}
          </ul>
          <h5 className="mb-3" data-aos="fade-up" data-aos-delay="200">Requirements </h5>
          <ul className="mb-3" data-aos="fade-up" data-aos-delay="200">
           {listRequirement}
          </ul>
          <h5 className="mb-3" data-aos="fade-up" data-aos-delay="200">Prefered Qualities</h5>
          <ul className="mb-3" data-aos="fade-up" data-aos-delay="200">
            {listQualities}
          </ul>
          <p>
         {summary}
          </p>
        </div>
        <div className="apply-right">
          <form className="apply-form" data-aos="fade-up" data-aos-delay="200">
            <h5 className="mb-4">Submit your application</h5>
            <hr className="apply-hr mb-4" />
            <label htmlFor="full-name">Full Name </label>
            <input className="mb-3" placeholder="e.g John Doe" id="full-name" />
            <label htmlFor="Email">Email </label>
            <input
              className="mb-3"
              placeholder="e.g johndoe@gmail.com"
              id="Email"
            />
            <label htmlFor="Message">Cover Letter </label>
            <textarea className="mb-3" placeholder="Message" />
            <button className="upload--cv mb-3">
              {" "}
              <img src={uploadCv} /> Upload your CV{" "}
            </button>
            <button className="submitApplication">Submit Application</button>
          </form>
        </div>
      </div>
   <Footer/>
           <div className='height'> 

              </div>
    </>
  );
};

export default CareerDetail;
